<template>
    <div id="header" class="table span">
        <div class="flex layout-50">
            <div class="btn flex" @mouseenter="LogoHover($event, false)" @mouseleave="LogoHover($event, true)" @click="GoHome()">
                <div id="logo-wrapper">
                    <div id="brands">
                        <Logo type="Emblem" :size="100"/>
                        <img id="profile" class="m-hide" src="@/assets/Images/BrandProfile.png" alt="Icon - Mike Ross" title="Mike Ross" width="75" height="75"/>
                    </div>
                </div>
                <div id="name-title" class="single">
                    <p id="name">Mike Ross</p>

                    <!-- Mobile-responsive -->
                    <div class="flex-y-center name-details p-desktop">
                        <span class="title">Creative Leader</span>
                        <span class="divider"></span>
                        <span class="title-detail">Developer, Engineer &amp; Visual Designer</span>
                    </div>
                    <div class="flex-y-center name-details p-mobile single">
                        <p class="title">Creative Leader</p>
                        <p class="title-detail">Developer, Engineer &amp; Visual Designer</p>
                    </div>

                </div>
            </div>
            <div class="flex-right layout p-desktop">
                <div id="header-right" class="flex right">
                    <div id="primary-navigation" class="flex-y-center">
                        <Navigation
                            v-for="(item, i) in Navigations['Primary']"
                            :key="i"
                            :item="item"
                            :mobile="mobile"
                            @sub-navigation-navigate="SubNavigationNavigate($event)"
                        />
                    </div>
                    <div class="divider-vertical"></div>
                    <SocialConnect/>
                </div>
            </div>
        </div>
        <div id="m-menu" class="m-span p-mobile">
            <img class="btn" src="@/assets/Images/M/IconMenu.png" alt="Icon - Menu" title="Menu" width="50" height="35" @click="ToggleMobileMenu(true)" v-if="!showMobileMenu"/>
            <img id="m-menu-close" class="btn right" src="@/assets/Images/Close.png" alt="Icon - Close" title="Close" width="53" height="53" @click="ToggleMobileMenu(false)" v-if="showMobileMenu"/>
            <div id="m-primary-navigation-wrap" v-if="showMobileMenu">
                <div id="m-primary-navigation">
                    <Navigation
                        v-for="(item, i) in Navigations['Primary']"
                        :key="i"
                        :item="item"
                        :mobile="mobile"
                        @sub-navigation-navigate="SubNavigationNavigate($event)"
                    />
                    <div class="flex-center m-row">
                        <SocialConnect/>
                    </div>
                </div>
            </div>
        </div>
        <SubNavigation
            :navigation="Navigations['Projects']['SubNavigation']"
            :show="navigationProjectsActive && CONFIG.projects.showSubNavigation"
        />
    </div>
    <Overlay
        :show="showMobileMenu"
        :opacity=".5"
        @click="ToggleMobileMenu(false)"
    />
</template>

<script>
import Navigations from "@/assets/JS/Data/Navigation.json";
import Navigation from "@/components/Template/Navigation.vue";
import SubNavigation from "@/components/Template/SubNavigation.vue";
import Logo from "@/components/Logo.vue";
import SocialConnect from "@/components/SocialConnect.vue";
import Overlay from "@/components/Overlay.vue";
import { Animation } from "@/assets/JS/Animation.js";
import {
    CONFIG,
    profile
} from "@/assets/JS/Config.js";
import $ from "jquery";

export default {
    name: "Header",
    props: { mobile: Boolean },
    components: {
        Navigation,
        SubNavigation,
        Logo,
        SocialConnect,
        Overlay
    },
    data: () => ({
        Navigations,
        showMobileMenu: false,
        navigationProjectsActive: false,
        CONFIG,
        paletteDetailsActive: false
    }),
    methods: {
        LogoHover: function(target, over) {
            if (!this.mobile) {
                const $target = $(target.target);
                const $brands = $target.find("#brands");
                const top = over ? "0" : "-80px";
                new Animation($brands, "Top", top, 200, 0);
            }
        },
        GoHome: function() {
            const route = this.$router.getRoutes().filter(r => r.name === "Main")[0];
            route.meta.profileContent.content = profile.defaultLandingPage;
            this.$router.push({
                name: "Main",
                meta: route.meta
            });
        },
        ToggleMobileMenu: function(state) { this.showMobileMenu = state; },
        SubNavigationNavigate: function(subNavigationItem) {
            this.$emit("sub-navigation-navigate", subNavigationItem);
            this.paletteDetailsActive = subNavigationItem !== profile.defaultLandingPage;
            if (this.mobile) {
                this.showMobileMenu = false;
            }
        }
    },
    beforeMount: function() {
        this.navigationProjectsActive = this.$route.fullPath === "/";
    },
    emits: [ "sub-navigation-navigate" ]
};
</script>